module.exports = __webpack_public_path__ + "pm.db648c849bfba5fab14d.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/pm.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/pm.svg
// module chunks = styles